<template lang="pug">
    .container
      include ResourcesEntrada.pug
</template>

<script>
import _ from "underscore"
import Api from "@/components/services/Api";
import { mapState } from 'vuex'

export default {
  name: 'ResourcesEntrada',
  props: [
    'slug'
  ],
  computed: mapState([
    "token",
    "context",
  ]),
  data () {
    return {
      resource: null,
      plan: null,
    }
  },
  async created() {
    // Me information
    const meResponse = await Api.me(this.token)
    const dataMe = meResponse.data
    const plan = dataMe.plan
    this.plan = plan

    const resourceResponse = await this.$wagtail.getResource(this.slug)
    const data = resourceResponse.data
    const resource = _.first(data.results)

    let available = true

    switch (this.plan) {
      case "basic":
        if (!resource.on_basic) available = false
        break;
      case "estandar":
        if (!resource.on_estandar) available = false
        break;
      case "premium":
        if (!resource.on_premium) available = false
        break;
    }

    if (!available) {
      this.$router.push({
        name: "Resources"
      })
    } else {
      this.resource = resource
    }

  }
}
</script>

<style lang="scss">
@import "./../../variables";

.page-heading {
  margin-bottom: 2.5rem;

  @include breakpoint($breakpoint-tablet) {
    margin-bottom: 1rem;
  }
}

.recurso-post-title {
  font-size: 2.25rem;
  padding-bottom: 2.5rem;

  @include breakpoint($breakpoint-tablet) {
    font-size: 1.75rem;
  }
}

.recommended-title {
  font-size: 2rem;
  padding-bottom: 3.5rem;
  font-weight: bold;
}

.article h3.title-article {
  padding-bottom: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcesEntrada.vue